import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'psnb-mobile-power-supply-telemetry-thresholddialog',
  templateUrl: './power-supply-telemetry-thresholddialog.component.html',
  styleUrls: ['./power-supply-telemetry-thresholddialog.component.scss']
})
export class PowerSupplyTelemetryThresholddialogComponent implements OnInit {

  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<PowerSupplyTelemetryThresholddialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
  }

}
